import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EStatMeasure, MatchStat } from '../../models';

@Component({
  selector: 'app-stats-indicator',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './stats-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatsIndicatorComponent {
  data = input.required<MatchStat>();

  getStatsName() {
    return this.data().Kind;
  }

  getHomeStats() {
    return (
      this.data().HomeValue +
      (this.data().Measure === EStatMeasure.PERCENTAGE ? '%' : '')
    );
  }

  getAwayStats() {
    return (
      this.data().AwayValue +
      (this.data().Measure === EStatMeasure.PERCENTAGE ? '%' : '')
    );
  }

  getHomeStatsPercentage() {
    if (this.data().Measure === EStatMeasure.PERCENTAGE) {
      return this.data().HomeValue;
    }

    const total = this.data().HomeValue + this.data().AwayValue;

    if (total == 0) return 0;

    return (this.data().HomeValue / total) * 100;
  }

  getAwayStatsPercentage() {
    if (this.data().Measure === EStatMeasure.PERCENTAGE) {
      return this.data().AwayValue;
    }

    const total = this.data().HomeValue + this.data().AwayValue;

    if (total == 0) return 0;

    return (this.data().AwayValue / total) * 100;
  }
}
